import { styled } from 'linaria/react';

import { COLORS } from 'styles/constants';
import { ReactComponent as Divider } from 'assets/icons/Divider.svg';
import { StyledBody, StyledFooter as ImportFooter } from '../Common/styled';

export const StyledWrap = styled(StyledBody)`
  border-radius: 0;
  gap: 16px;
  padding: 40px 12px 24px;
`;

export const StyledImage = styled.img<{ isAnimating?: boolean }>`
  border-radius: 8px;
  height: auto;
  max-height: 506px;
  object-fit: cover;
  object-position: center;
  position: relative;
  width: 100%;
  transform-origin: center center;
  transition: none;
  animation: ${({ isAnimating }) =>
    isAnimating ? 'breathingAndRotation 8.4s cubic-bezier(0.66, 0.00, 0.31, 1.00) infinite' : 'none'};
`;

// Define keyframes separately to avoid CSS parsing issues
const keyframes = `
  @keyframes breathingAndRotation {
    /* Breathing phase: 0s to 4.25s (4.25s duration) - single breath cycle */
    0% {
      transform: scale(1) rotateY(0deg);
    }
    25.3% {
      transform: scale(0.95) rotateY(0deg);
    }
    50.6% {
      transform: scale(1) rotateY(0deg);
    }
    
    /* Rotation phase: 4.25s to 8.4s (4.15s duration) */
    50.6% {
      transform: scale(1) rotateY(0deg);
    }
    100% {
      transform: scale(1) rotateY(-360deg);
    }
  }
`;

// Inject keyframes into the document
if (typeof document !== 'undefined') {
  // Check if keyframes already exist to avoid duplicates
  const existingStyle = document.querySelector('style[data-breathing-animation]');
  if (!existingStyle) {
    const style = document.createElement('style');
    style.setAttribute('data-breathing-animation', 'true');
    style.textContent = keyframes;
    document.head.appendChild(style);
  }
}

export const StyledLink = styled.a`
  color: ${COLORS.white[100]};
  text-decoration: none;
`;

export const StyledContent = styled.div<{ isReverse?: boolean }>`
  display: flex;
  gap: ${({ isReverse }) => (isReverse ? 16 : 0)}px;
  flex-direction: ${({ isReverse }) => `column${isReverse ? '-reverse' : ''}`};
`;

export const StyledFooter = styled(ImportFooter)<{ hasImage: boolean }>`
  margin-top: ${({ hasImage }) => (hasImage ? 0 : -16)}px;
  padding: 0 12px 0;
  display: flex;
  height: 20px;
  padding: 0px 8px 0px 12px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  align-self: stretch;
`;

export const StyledDivider = styled(Divider)`
  color: ${COLORS.white[100]};
  padding: 0 12px;
`;
